import React from "react";
import Page from "components/Page/Page";
import { Grid, Row, Col } from "components/Grid/Grid";

function Ai() {
  return (
    <Page currentPage="ai">
      <Grid width="80%">
        <Row>
          <Col size={1}>
            <p>Coming soon.</p>
          </Col>
        </Row>
      </Grid>
    </Page>
  );
}

export default Ai;
